import {APP, GET, POST} from "../util";

const inspectionUrl = "api/seller-payments/initiation/inspection";
const operationUrl = "api/seller-payments/initiation/operation"

const url = {
    inspection: {
        details: `${inspectionUrl}/details/:recordId`,
        downloadLink: `${inspectionUrl}/download-info/:recordId`,
    },
    operation: {
        startClearingPayment: `${operationUrl}/start-clearing-payment`,
    }
};

const sellerPaymentsInitiationApi = {
    inspection: {
        getManualTransferDetails: (recordId) => {
            return GET(url.inspection.details.replace(":recordId", recordId));
        },
        getManualPaymentInfoDownloadLink: (recordId) => {
            return APP.DOMAIN + url.inspection.downloadLink.replace(":recordId", recordId);
        }
    },
    operation: {
        startClearingPayment: (params = {}) => {
            return POST(url.operation.startClearingPayment, params);
        }
    }
};

export {
    sellerPaymentsInitiationApi
};